import {getRequest, postRequest} from "../fetchWrapper";

/**
 * Récupération de la liste des produits d'une agence.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAgencyProductList = (token, agencyId) => {
    const url = `/api-v1/admin/agency/${agencyId}/product/list`
    return getRequest(url, token)
}

/**
 * Récupération de la liste des produits.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getProductList = (token, pageNumber, itemsPerPage) => {
    const url = `/api-v1/admin/product/${pageNumber}/${itemsPerPage}/list`
    return getRequest(url, token)
}

/**
 * Mise à jour des produits.
 *
 * @param string $token Jeton d'authentification.
 * @param object body Liste des produits à mettre à jour.
 */
export const updateProductList = (token, body) => {
    const url = `/api-v1/admin/product/list/update`
    return postRequest(url, body, token)
}

/**
 * Récupération des informations d'un produit.
 *
 * @param string $token Jeton d'authentification.
 * @param int $productType Identifiant du produit.
 */
export const getProductInfos = (token, productId) => {
    const url = `/api-v1/admin/product/${productId}/infos`
    return getRequest(url, token)
}

/**
 * Récupération de la liste des types de produit.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getProductTypeList = (token) => {
    const url = `/api-v1/admin/product/type/list`
    return getRequest(url, token)
}

/**
 * Création d'un produit.
 *
 * @param string $token Jeton d'authentification.
 * @param object body Informations du produit à créer.
 */
export const createProduct = (token, body) => {
    const url = `/api-v1/admin/product/create`
    return postRequest(url, body, token)
};

/**
 * Suppression d'un produit.
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Identifiant du produit à supprimer.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const deleteProductFromDb = (token, body) => {
    const url = `/api-v1/admin/product/delete`
    return postRequest(url, body, token)
};

/**
 * Modification de la visibilité d'un produit.
 *
 * @param string $token Jeton d'authentification.
 * @param object body Informations du produit à modifier.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const setProductEnabled = (token, body) => {
    const url = `/api-v1/admin/product/enable`
    return postRequest(url, body, token)
};
